import React from "react"
import Form from "react-bootstrap/Form"
import { useIntl } from "react-intl"

const CurrencySelector = ({ value, onChange }) => {
  const intl = useIntl()

  const currencies = [
    { code: "BTC", name: "Bitcoin" },
    { code: "ETH", name: "Ethereum" },
    { code: "XRP", name: "Ripple" },
    { code: "LTC", name: "Litecoin" },
    { code: "DOGE", name: "Dogecoin" },
    { code: "ADA", name: "Cardano" },
    { code: "SOL", name: "Solana" },
    { code: "BCH", name: "Bitcoin Cash" },
    { code: "DOT", name: "Polkadot" },
    { code: "MATIC", name: "Polygon" },
    { code: "LINK", name: "Chainlink" },
    { code: "UNI", name: "Uniswap" },
    { code: "ALGO", name: "Algorand" },
    { code: "ATOM", name: "Cosmos" },
    { code: "XLM", name: "Stellar" },
    { code: "FIL", name: "Filecoin" },
    { code: "BNB", name: "Binance Coin" },
    { code: "WBTC", name: "Wrapped Bitcoin" },
    { code: "SHIB", name: "Shiba Inu" },
    { code: "VET", name: "VeChain" },
    { code: "BAT", name: "Basic Attention Token" },
    { code: "AXS", name: "Axie Infinity" },
    { code: "USDC", name: "USD Coin" },
  ]

  // Handle keyboard navigation (native select already supports arrow keys)
  // This handler is for additional keyboard support if needed
  const handleKeyDown = (e) => {
    // Native select elements already handle:
    // - Arrow Up/Down to navigate options
    // - Enter/Space to open dropdown
    // - Type to search
    // - Escape to close
    // So we just ensure the element is focusable and let native behavior work
  }

  return (
    <Form.Control
      as="select"
      value={value}
      onChange={e => onChange(e.target.value)}
      onKeyDown={handleKeyDown}
      aria-label={intl.formatMessage({ id: "Select Cryptocurrency" })}
      tabIndex={0}
    >
      {currencies.map(currency => (
        <option key={currency.code} value={currency.code}>
          {intl.formatMessage({ id: currency.name })} ({currency.code})
        </option>
      ))}
    </Form.Control>
  )
}

export default CurrencySelector
